import React from "react";

export default function FactsAndHelp() {
  return (
    <div>
      {/* Hero Header */}
      <div className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white animated slideInDown">
                FAQs & Help
              </h1>
              <p className="fs-4 text-white mb-4 animated slideInDown">
                Everything you need to know before you travel.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Facts & Help Content */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">

              <h4 className="mb-3">What We Do</h4>
              <p className="mb-4">
                The Outpost Gentlemen, Outpost Travel curates elevated travel experiences designed for
                those who value comfort, discretion, and thoughtful planning. We focus
                on quality over quantity, ensuring every journey feels intentional and
                effortless.
              </p>

              <h4 className="mt-5 mb-3">Who We Work With</h4>
              <p className="mb-4">
                We work with individuals, couples, private groups, and corporate clients
                seeking refined travel planning and concierge-style service.
              </p>

              <h4 className="mt-5 mb-3">How Booking Works</h4>
              <p className="mb-4">
                Booking begins with a consultation. From there, we curate recommendations and manage logistics
                based on your preferences.
              </p>

              <h4 className="mt-5 mb-3">Do You Charge Planning Fees?</h4>
              <p className="mb-4">
                Planning fees may apply depending on the scope and complexity of your
                request. Any fees will be disclosed clearly before work begins.
              </p>

              <h4 className="mt-5 mb-3">Can I Make Changes After Booking?</h4>
              <p className="mb-4">
                Yes. Changes are subject to availability and supplier policies. We’ll
                always communicate any impacts on pricing or availability in advance.
              </p>

              <h4 className="mt-5 mb-3">Cancellations & Refunds</h4>
              <p className="mb-4">
                Cancellation policies vary by supplier and service type. Specific terms
                will be provided before confirmation.
              </p>

              <h4 className="mt-5 mb-3">Travel Documents & Requirements</h4>
              <p className="mb-4">
                Travelers are responsible for ensuring they have valid passports,
                visas, and required documentation. We recommend verifying requirements
                well in advance of travel.
              </p>

              <h4 className="mt-5 mb-3">Health & Safety</h4>
              <p className="mb-4">
                While we prioritize reputable partners and destinations, travelers are
                responsible for assessing personal health and safety risks.
              </p>

              <h4 className="mt-5 mb-3">Need Help?</h4>
              <p className="mb-1">
                If you have questions or need assistance, we’re here to help.
              </p>
              <p className="mb-1">Email: david.murphy@fora.travel</p>
              <p className="mb-4">Website: theoutposttravel.com</p>

            </div>
          </div>
        </div>
      </div>
      {/* Facts & Help Content End */}
    </div>
  );
}
